import SiteNav from './components/SiteNav';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import SynopsisSection from './components/SynopsisSection';
import CharactersSection from './components/CharactersSection';
import EpisodesSection from './components/EpisodesSection';
import TimelineSection from './components/TimelineSection';
import EndingSection from './components/EndingSection';
import ThemesSection from './components/ThemesSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <HeroSection />
        <OverviewSection />
        <SynopsisSection />
        <CharactersSection />
        <EpisodesSection />
        <TimelineSection />
        <EndingSection />
        <ThemesSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}